import React from "react";
import "../../assets/css/step-Header.css";
import { useNavigate } from "react-router-dom";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import LanguageSwitcher from "../../components/ui/LanguageSwitcher/LanguageSwitcher";

const StepHeader = ({ title, onBack, showIcon, step }) => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleHome = () => {
    navigate("/");
  };

  const steps = ["Step 1", "Step 2", "Step 3", "Step 4"];

  const renderDotTimeLine = () => {
    return steps.map((_, index) => {
      const isActive = step === index + 1;
      const isPast = step > index + 1;

      return (
        <div
          key={index}
          className={`timeline-step ${isActive ? "active" : ""} ${
            isPast ? "past" : ""
          }`}
          style={index === steps.length - 1 ? { width: "fit-content" } : {}}
        >
          <img
            style={{ width: 30, height: 30, zIndex: 100 }}
            src={
              isPast
                ? "/assets/img/ci/img/loan/past-dot.svg"
                : isActive
                ? "/assets/img/ci/img/loan/current-dot.svg"
                : "/assets/img/ci/img/loan/default-dot.svg"
            }
          />
          {index !== steps.length - 1 && (
            <div style={{ marginLeft: 6 }} className="lineContent">
              <div className="line" style={{ backgroundColor: "#ccc" }}></div>
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <header className="main-header">
      <div className="tHead">
        {!isDesktop && onBack ? (
          <a onClick={handleBack} className="back-button" href="#"></a>
        ) : (
          <div style={{ width: "40%" }}></div>
        )}

        {title !== "" ? (
          <div className="tTitle tTitle-center">
            <h2>{title}</h2>
          </div>
        ) : (
          <div className="bHeadIcon" onClick={handleHome}>
            <img src="/assets/img/ci/icon/icon-aunjai.svg" />
          </div>
        )}

        {/* LanguageSwitcher placed same way as Header.jsx */}
        <div className="bLanguage">
          <LanguageSwitcher />
        </div>
      </div>

      {step && <div className="timeline-container">{renderDotTimeLine()}</div>}
    </header>
  );
};

export default StepHeader;
